// In development (https://localhost:3000) we rely on CRA proxy; leave base empty to use relative URLs
const isLocal =
  typeof window !== 'undefined' &&
  window.location.hostname === 'localhost' &&
  window.location.port === '3000';

const env = process.env.REACT_APP_ENV ?? (isLocal ? 'development' : 'production');

const resolvedApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ??
  (isLocal ? '' : env === 'production'
    ? 'https://app-prt-claire-prd-weu-backend.azurewebsites.net'
    : 'https://app-prt-claire-dev-weu-backend.azurewebsites.net');

const resolvedAuthority =
  process.env.REACT_APP_AUTHORITY ??
  (env === 'production'
    ? 'https://api.boma.eu/identity'
    : 'https://apitest.boma.eu/identity');

export const apiBaseUrl = resolvedApiBaseUrl;

// Authentication configuration for Boma Identity Server
export const authConfig = {
  clientId: 'boma-chatbot', // Replace with your actual client ID
  authority: resolvedAuthority,
  redirectUri: window.location.origin + '/auth-callback.html',
  postLogoutRedirectUri: window.location.origin,
  audience: apiBaseUrl,
  apiBaseUrl, // <- toegevoegd zodat chatApi.ts dit kan lezen
  scopes: ['openid', 'profile', 'chatbot', 'offline_access'],
};